import React, { useEffect } from 'react';
import Webfont from 'webfontloader';

export interface Props {
  children?: React.ReactNode;
}
/**
 *
 */
const LoadFont: React.FC<Props> = () => {
  useEffect(() => {
    Webfont.load({
      classes: false,
      google: {
        families: ['Muli', 'Rubik', 'Rubik:300', 'Rubik:500', 'Manrope'],
      },
    });
  }, []);
  return <></>;
};

export default LoadFont;
